// extracted by mini-css-extract-plugin
export default {"wrap":"HeroBookDemoCta_wrap__1OPd+","link":"HeroBookDemoCta_link__gLG43"};